import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-admin-locations',
  templateUrl: './admin-locations.component.html',
  styleUrls: ['./admin-locations.component.scss']
})
export class AdminLocationsComponent implements OnInit {

  tabLocations = {
    refreshUrl: 'locations/list',
    detailUrl: 'admin/locations',
    detailId: 'id_location',
    cols: [
      { type: 'text', attr: 'name', header: 'Název' },
      { type: 'text', attr: 'client_name', header: 'Klient' },
      { type: 'text', attr: 'city', header: 'Město' },
      { type: 'text', attr: 'street', header: 'Ulice' },
      { type: 'bool', attr: 'is_active', header: 'Aktivní' }
    ]
  };

  constructor(
    public shared: SharedService,
    private router: Router
  ) {}

  ngOnInit(): void { }

  addLocation(): void {
    this.router.navigate(['/admin/locations/new']);
  }
}
